// extracted by mini-css-extract-plugin
export var truncate = "_d-0";